import hetong from '../views/hetong'

export default {
  path: '/hetong',
  component: hetong,
  redirect: '/hetong/hetongList',
  name: 'Hetong',
  meta: {
    title: '合同管理'
  },
  children: [
    {
      path: '/hetong/hetongList',
      component: () => import('../views/hetong/htList'),
      name: 'hetongList',
      meta: {
        title: '合同列表'
      }
    },
    {
      path: '/hetong/hetongcgList',
      component: () => import('../views/hetong/htcgList'),
      name: 'hetongList',
      meta: {
        title: '合同列表'
      }
    },
    {
      path: '/hetong/whhetong',
      component: () => import('../views/hetong/whhetong'),
      name: 'whhetong',
      meta: {
        title: '合同维护'
      }
    },
    {
      path: '/hetong/whhetongList',
      component: () => import('../views/hetong/whhetongList'),
      name: 'whhetongList',
      meta: {
        title: '维护列表'
      }
    }

  ]

}
